import { AddTreatmentResponseDto } from "@/data/dto/treatment-source/add-treatment-response-dto";
import { AddTreatmentResponseEntity } from "@/domain/entity/treatment/add-treatment-response-entity";
import { assertAddTreatmentResponseDto } from "@/utils/validation";

export class AddTreatmentResponseInfoMapper {
  static toEntity(dto: AddTreatmentResponseDto): AddTreatmentResponseEntity {
    // AST 기반 타입 검증
    assertAddTreatmentResponseDto(dto);
    return {
      newTreatmentUuid: dto.newTreatmentUuid,
      terminatedTreatmentUuid: dto.terminatedTreatmentUuid ?? "",
    };
  }
}
